import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { hasUsableSession } from '../../utils/authSession';
import ForcePasswordChange from './ForcePasswordChange';

function readStoredToken() {
  try {
    return localStorage.getItem('token');
  } catch {
    return null;
  }
}

// --- COMPONENTE "GUARDIÁN" PARA RUTAS PRIVADAS ---
// Single predicate (hasUsableSession) shared with usePostLoginRedirect so the two can never
// disagree and ping-pong /login ↔ /app. A present, non-expired token → render; otherwise → /login.
function PrivateRoute({ children }) {
  const { token, mustChangePassword, loginPasswordRef } = useAuth();
  const location = useLocation();
  const effectiveToken = token || readStoredToken();

  if (!hasUsableSession(effectiveToken)) {
    const currentPath = location.pathname + location.search;
    if (currentPath && currentPath !== '/' && currentPath !== '/login' && currentPath !== '/app') {
      sessionStorage.setItem('redirectAfterLogin', currentPath);
    }
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {children}
      <ForcePasswordChange
        show={mustChangePassword}
        currentPassword={loginPasswordRef?.current || ''}
      />
    </>
  );
}

export default PrivateRoute;
